export class PromotoraDocumentoDTO {
  public id!: string | null;
  public idPromotora!: number;
  public codigoChecklist!: number;
  public nomeChecklist!: string;
  public vigencia!: string;
  public apresentacao!: string;
  public impeditivoAbertura!: boolean;
  public impeditivoBloqueioCodigo!: boolean;
  public permiteNaoSeAplica!: boolean;
  public arquivoObrigatorio!: boolean;
  public naoSeAplica!: boolean;
  public pendenteCorrecao!: boolean;
  public documentoAdicional!: boolean;
  public descricaoDocumento!: string;
  public observacaoPendencia!: string;
  public possuiModelo!: boolean;
  public modeloArquivo!: string;
  public statusChecklist!: string;
  public arquivoBase64!: string;
  public nomeArquivo!: string;
  public caminhoArquivo!: string;
  public idUsuarioCadastro!: number;
  public nomeUsuarioCadastro!: string;
  public dtInclusao!: Date;
}
